<template>
    <div>
        <HeadDetailsGama
          v-on:save="onSubmit"
          @nextstatus="$emit('nextstatus')"
          v-on:cancel="backPage"
          :btnCanceSave="!flDisable"
          :titleHead="'Lista de Chamados'">
        </HeadDetailsGama>
        <div id="formDetails" class="mt-2">
            <p class="subtitle_Dados"> Dados do Cliente </p>
            <div class="Dados_Client">
                <div class="d-flex inputgroup">
                    <div class="col-4 campoTriagem">
                        <p class="p_Name"> Nome </p>
                        <input :disabled="flDisable" v-model="dataDetails.nomeMorador"
                        class="input_sorting">
                    </div>
                    <div class="col-4 campoTriagem">
                        <p class="p_Name">E-mail</p>
                        <input :disabled="flDisable" v-model="dataDetails.email"
                        class="input_sorting">
                    </div>
                    <div class="campocpf campoTriagem">
                        <p class="p_Name"> CPF </p>
                        <input :disabled="flDisable" v-model="dataDetails.cpf"
                        class="input_sorting"
                        v-mask="['###.###.###-##']">
                    </div>
                </div>
                <div class="inputClient">
                    <div class="d-flex inputgroupsecond">
                        <div class="campoTriagemCelular">
                            <p class="p_Name"> Celular </p>
                            <input :disabled="flDisable" v-model="dataDetails.celular"
                        class="input_SecondLine"
                        v-mask="['(##) #####-####']">
                    </div>

                    <div class="campoTriagemTel">
                        <p class="p_Name"> Telefone </p>
                        <input :disabled="flDisable" v-model="dataDetails.telefone"
                        class="input_SecondLine"
                        v-mask="['(##) ####-####']">
                    </div>
                    </div>
                    <div class="d-flex inputgroupenterprise">
                        <div class="campoTriagem">
                            <p class="p_Name"> Empreendimento </p>
                            <select class="form-control" @change="getunityenterpriseNewUnit" :disabled="flDisable" v-model="dataDetails.empreendimentoNovaUnidadeId">
                                <option v-for="data in dataallenterprise" :key="data.id" :value="data.id">
                                    {{data.nomeUnidade}}
                                </option>
                            </select>
                        </div>
                        <div class="campoTriagem">
                            <p class="p_Name">Unidade: </p>
                            <input :disabled="flDisable" v-model="dataDetails.nomeUnidade"
                            class="input_sorting">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Solicitation_call">
            <p class="subtitle_Dados"> Solicitação de Chamado </p>
                <div class="description_problem">
                    <p class="p_Name_descricao"> Descrição do Problema</p>
                        <b-form-textarea
                            :disabled="flDisable"
                            id="textarea-large"
                            size="lg"
                            placeholder="Descreva o problema..."
                            v-model="dataDetails.descricao"
                            class="descriptionOcurrence"
                        >
                        </b-form-textarea>
                </div>
        </div>
        <div class="PdfVistoria">
            <!-- <p class="subtitle_Dados"> PDF Vistoria Técnica </p> -->
            <div class="pdfDownload">
                    <!-- <div class="triagem_container" @click="$emit('openpdf')"> -->
                    <div class="triagem_container" @click="openpopPdf">
                        <img class="pdfTriagem" src="../InfoSorting/PdfPictures/Ilustra triagem.svg"/>
                        <div class="donwloadTriagem"> Baixar PDF Triagem / Vistoria Técnica </div>
                    </div>
            </div>
        </div>
        <b-modal
            hide-footer
            centered
            size="lg"
            ref="popup-pdf-modal"
            id="history-lote">
            <template #modal-header>
                <div class="d-flex justify-content-between align-items-center align-content-center w-100" style="color:#fff">
                    <p id="title-modal">FORMULÁRIO TRIAGEM / VISTORIA TÉCNICA</p>
                    <div class="d-flex">
                        <i class="fa fa-download d-flex mr-4 justify-content-between align-items-center align-content-center"
                            style="color: #fff; cursor: pointer;"
                            @click="$emit('openpdf')"
                            v-b-tooltip.hover.bottom title="Download"></i>
                        <div @click="closeModal" class="w-100" id="closed-modal">x</div>
                    </div>
                </div>
            </template>
            <div>
                <div>
                </div>
                <section slot="pdf-content">
                    <div class="pdf-header">
                        <img src="/static/img/logotipo/menu/logo_zopone.png" class="size-logo-inco-pdf"/>
                    </div>
                    <div>
                        <tr>
                        <td class="codigoposition">Chamado N° <b>
                            {{dataDetailsPdf.codigo}}
                        </b></td>
                        </tr>
                    </div>
                    <div class="container-pdf">
                        <div class="sub-title">1 - SOLICITANTE</div>
                        <table class="table-pdf">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td v-if="dataDetailsPdf.empreendimentoNovaUnidade"  class="table-pdf-td">EMPREENDIMENTO:
                                         <b>{{dataDetailsPdf.empreendimentoNovaUnidade.nomeEmpreendimento}}</b>
                                    </td>
                                    <td class="table-pdf-td">
                                        UNIDADE:
                                        <b>
                                            {{dataDetailsPdf.nomeUnidade}}
                                        </b>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="table-pdf-td">ENDERECO: <b>
                                        <!-- {{dataDetailsPdf.empreendimento.endereco}} -->
                                    </b></td>
                                    <td class="table-pdf-td">CIDADE: <b>
                                        <!-- {{dataDetailsPdf.cidade.nome}} -->
                                    </b></td>
                                </tr>
                                <tr>
                                    <td class="table-pdf-td">NOME DO SOLICITANTE: <b>
                                        {{dataDetailsPdf.nomeCliente}}
                                    </b></td>
                                    <td class="table-pdf-td">FONE: <b>
                                        {{dataDetailsPdf.telefone}}
                                    </b></td>
                                </tr>
                                <tr>
                                    <td class="table-pdf-td" v-if="dataDetailsPdf.tecnico" >RESP. VISITA TÉCNICA: <b>{{dataDetailsPdf.tecnico.nome}}</b></td>
                                    <td class="table-pdf-td">
                                        <div class="dataandhour">
                                        <div>
                                            DATA:
                                            <b>
                                                {{dataDetailsPdf.dataString}}
                                            </b>
                                        </div>
                                        <div>
                                            HORA:
                                            <b>
                                                {{dataDetailsPdf.horario == null ? "HORÁRIO NÃO CADASTRADO" : formatHours(dataDetailsPdf.horario)}}
                                            </b>
                                        </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="sub-title">2 - DESCRIÇÃO DA SOLICITAÇÃO</div>
                        <table class="table-pdf">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td class="td-tratamento">{{dataDetailsPdf.descricao}}</td>
                                </tr>
                                <tr>
                                    <td class="td-tratamento"></td>
                                </tr>
                                <tr>
                                    <td class="td-tratamento"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="d-flex sub-title">3 - PARECER DA VISITA TÉCNICA GARANTIA
                            <input disabled type="checkbox"  id="check-garantia-true" class=" ml-3 mr-1"/>SIM
                            <input disabled type="checkbox" id="check-garantia-false" class="ml-3 mr-1"/>NÃO
                        </div>
                        <table class="table-pdf">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td class="td-tratamento"></td>
                                </tr>
                                <tr>
                                    <td class="td-tratamento"></td>
                                </tr>
                                <tr>
                                    <td class="td-tratamento"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="d-flex sub-title">3.1 - TIPOS DE PATOLOGIAS
                            <input disabled type="checkbox"   class=" ml-3 mr-1" />Manutenção Completa
                            <input disabled type="checkbox"  class="ml-3 mr-1" />Manutenção Incompleta
                        </div>
                        <div v-if="dataDetailsPdf.patologia !== undefined">
                        <table class="w-100">
                            <thead></thead>
                            <tbody>
                                <tr>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 2)" />
                                    <div>Pisos e Revestimento</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 1)" />
                                    <div>Elétrica</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 4)" />
                                    <div>Vedação Interna e Externas</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 5)" />
                                    <div>Pintura</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 6)" />
                                    <div>Louças e Metais</div>
                                    </div>
                                </td>
                                </tr>
                                <tr>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 7)" />
                                    <div>Hidráulica</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 0)" />
                                    <div>Infiltração</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 3)" />
                                    <div>Esquadrias, janelas e portas</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 8)" />
                                    <div>Tubulações</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 9)" />
                                    <div>Estrutura</div>
                                    </div>
                                </td>
                                </tr>
                                <tr>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 10)" />
                                    <div>Impermeabilização</div>
                                    </div>
                                </td>
                                <td class="check-patologia-td">
                                    <div class="d-flex check-table">
                                    <input disabled type="checkbox" :checked="dataDetailsPdf.patologia.some(p => p.patalogiaInt === 11)" />
                                    <div>Outros</div>
                                    </div>
                                </td>
                                </tr>
                            </tbody>
                            </table>
                        </div>

                        <div class="d-flex justify-content-between">
                        </div>
                        <div class="d-flex sub-title"> 4 - AÇÕES PARA TRATAMENTO/MOTIVO DE IMPROCEDÊNCIA
                            <input disabled type="checkbox" class=" ml-3 mr-1 testechek" />Tratamento Procedente
                            <input disabled type="checkbox" class="ml-3 mr-1" />Tratamento Improcedente
                        </div>
                        <table class="w-100">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td colspan="2" class="td-tratamento"><b>Descrição</b></td>
                                </tr>
                                <tr>
                                    <td  colspan="2" class="td-tratamento"></td>
                                </tr>
                                <tr>
                                    <td class="td-tratamento w-50"></td>
                                    <td class="td-tratamento w-50"><b>Custo Estimado</b></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="d-flex sub-title">5 - AVALIAÇÃO DO CLIENTE</div>
                        <table class="w-100">
                            <thead>
                                <tr>
                                    <th class="td-avaliacao-cl">Descrição</th>
                                    <th class="text-center td-availiacao-check">Ótimo</th>
                                    <th class="text-center td-availiacao-check">Bom</th>
                                    <th class="text-center td-availiacao-check">Regular</th>
                                    <th class="text-center td-availiacao-check">Ruim</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="td-avaliacao-cl">Qualidade dos serviços prestados</td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                </tr>
                                <tr>
                                    <td class="td-avaliacao-cl">Tempo de resposta para atendimento</td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                </tr>
                                <tr>
                                    <td class="td-avaliacao-cl">Comportamento e cordialidade</td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                </tr>
                                <tr>
                                    <td class="td-avaliacao-cl">Organização e Limpeza</td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                    <td class="td-availiacao-check"></td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="d-flex sub-title">6 - TERMO DE ACEITAÇÃO FINAL</div>
                        <!-- <p><b>Eu,</b> {{ dataDetailsPdf.nomeCliente}} acima citado, declaro que os serviços/esckarecunebtis correspondem á solicitação apontadas neste relatório, foram realizadas/ prestadas a contento de forma clara e objetiva, Por tanto, estando ciente e
                        não tendo mais nada a reclamar, <b>aceito</b></p> -->

                        <div class="d-flex w-100 justify-content-between assinatura-body">
                            <div class=" w-25">
                                <div class="assinatura-row"></div>
                                <div class="text-center mt-3"><b>Visto Repres. da Empresa</b></div>
                            </div>
                            <div class=" w-25">
                                <div class="assinatura-row"></div>
                                <div class="text-center mt-3"><b>Nome e Assinat. Cliente</b></div>
                            </div>
                            <div class=" w-25">
                                <div class="assinatura-row"></div>
                                <div class="text-center mt-3"><b>Eng. Coord. QMA</b></div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>
    </div>
    </template>

<script>
import infoSorting from '@/views/private/realestate/ocurrence/components/InfoSorting/infoSorting'
export default infoSorting
</script>

    <style scoped>
    input[readonly] {
        pointer-events: none;
    }
    .PdfVistoria{
        height: 100%;
        display: flex;
        justify-content: initial;
    }
    .subtitle_Dados{
        grid-area: subtitle_Dados;
        color: #008148;
        font: normal normal 600 18px/24px Segoe UI;
        height: 24px;
    }

    .Dados_Client{
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        gap: 1rem 1.5rem;
    }

    .input_sorting{
        width: 100%;
        height: 35px;
        background-color: 100%;
        border: 1px solid #D4D9DE;
        border-radius: 5px;
        outline: none;
        padding-left: 0.5rem;
    }
    .input_SecondLine{
        width: 12rem;
        height: 35px;
        background-color: 100%;
        border: 1px solid #D4D9DE;
        border-radius: 5px;
        outline: none;
    }
    .container-buttons-form{
        grid-row: 6;
        grid-column: 1/11;
    }
    .p_Name{
        font: normal normal normal 16px/21px Segoe UI;
        color: #666666;
        text-align: left;
        margin: 0;
        font-weight: bold;
    }
    .p_Name_descricao{
        margin-bottom: 0.3rem;
        font: normal normal normal 16px/21px Segoe UI;
        color: #666666;
        text-align: left;
        font-weight: bold;
    }
    .description_problem{
        grid-area: description_problem;
        width: 100%;
    }
    .Solicitation_call{
        margin: 1rem auto;
    }

    .input[type=checkbox]{
        transform: scale(2);
        margin: 10px;
        cursor:pointer;
        background-color: #fff;
    }

    .pdfDownload{
       display: flex;
       text-align: center;
    }

    .triagem_container{
        display: flex;
        background-color: #008147d7;
        align-items: center;
        border-radius: 6px;
    }
    .pdfTriagem{
        display: flex;
    }
    .donwloadTriagem{
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        word-break: keep-all;
        width:8rem;
    }

    .campoTriagem{
        padding: 0;
        gap: 0.3rem;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .campocpf {
        width:100%;
    }
    .inputgroup{
        gap: 1rem;
        width: 100%;
    }

    .inputgroupsecond{
        gap:1rem;
    }

    .inputgroupenterprise{
        display: flex;
        gap: 1rem;
        width: 100%;
    }

    .inputClient{
        display: flex;
        gap: 1rem;
        width: 100%;
    }
    .campoTriagemCelular {
            padding: 0;
            gap: 0.3rem;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .campoTriagemTel{
            padding: 0;
            gap: 0.3rem;
            display: flex;
            flex-direction: column;
            width: 100%;
        }

        .descriptionOcurrence{
            font-size: 0.875rem;
            min-height: 8rem;
        }

    @media screen and (max-width: 1600px) {
        .PdfVistoria{
            height: 100%;
            display: flex;
            justify-content: initial;
        }
        .campoTriagemCelular{
            padding: 0;
            gap: 0.3rem;
            display: flex;
            flex-direction: column;
            width: auto;
        }
        .campoTriagemTel{
            padding: 0;
            gap: 0.3rem;
            display: flex;
            flex-direction: column;
            width: auto;
        }
        .inputClient{
            display: flex;
            gap: 1rem;
            flex-direction: column;
        }

        .input_sorting{
            width: 100%;
            height: 35px;
            background-color: 100%;
            border: 1px solid #D4D9DE;
            border-radius: 5px;
            outline: none;
        }

        .input_SecondLineApt{
            width: 100%;
            height: 35px;
            background-color: 100%;
            border: 1px solid #D4D9DE;
            border-radius: 5px;
            outline: none;
        }
        .input_SecondLine{
            width: 100%;
            height: 35px;
            background-color: 100%;
            border: 1px solid #D4D9DE;
            border-radius: 5px;
            outline: none;
            padding-left: 0.5rem;
        }
        .check-container {
            width: 6.5rem;
        }
        .secondGridLine {
            display: flex;
            flex-direction: inherit;
            gap: 1rem;
            justify-content: unset;
        }
        .second_line{
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
        .Dados_Client{
            grid-template-rows: repeat(2, .5fr);
        }
        .apartment{
            max-width: 6rem;
        }
    }
    @media screen and (min-width: 1600px) {
        .PdfVistoria{
        height: 100%;
        display: flex;
        justify-content: initial;
        margin-top: 9.5rem;
    }
    }

.check-patologia-td{
    height: 25px;
    min-height: 25px;
    max-height: 25px;
}
.main-container{
    position: relative;
}
.painel-detalhes-main{
    height: 73vh;
    overflow: auto;
    font-family: 'Segoe UI';
}

.painel-detalhes-main::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 15px;
}
.painel-detalhes-main::-webkit-scrollbar {
    width: 10px;
    height: 10px;
     border-radius: 9px;
    background: #F4F4F4;
}
.painel-detalhes-main::-webkit-scrollbar-thumb {
    background: rgb(192, 193, 192);
    border-radius: 9px;
}

/* PDF */
.container-pdf{
    padding: 3px 20px 5px 20px;
}
.table-pdf{
    border: 1px solid black;
    width: 100%;
}
.assinatura-body{
    margin-top: 60px;
}
.testechek{
 accent-color: green;
}
.pdf-header{
    height: 7vh;
    display: flex;
    align-items: center;
    padding-left: 25px;
    background: #e4e5e6;
}

.codigoposition{
    padding-left: 40rem;
    /* display: flex;
    height: 100%;
    width: 100%;
    justify-content: end;
    align-items: center; */
}

.sub-title{
    font-weight: bold;
    margin-bottom: 5px;
    margin-top: 25px;
}
.td-tratamento{
    min-height: 25px;
    max-height: 25px;
    height: 25px;
    padding-left: 15px;
    border: 1px solid gray;
    width: 100%;
}
.assinatura-row{
    width: 100%;
    height: 2px;
    background: gray;
}
.table-pdf-td{
    border: 1px solid gray;
    width: 50%;
    padding-left: 10px;
    min-height: 25px;
    height: 25px;
    max-height: 25px;
}
.td-avaliacao-cl{
    width: 60%;
    min-height: 25px;
     height: 25px;
    max-height: 25px;
    padding-left: 10px;
    border: 1px solid gray;
}
.size-logo-inco-pdf{
    height: 50px;
    width: 250px;
}
.td-availiacao-check{
    width: 10%;
    height: 25px;
    min-height: 25px;
    max-height: 25px;
    padding-left: 10px;
    border: 1px solid gray;
}
.check-table
{
    height: 15px;
    display: flex;
    align-items: center;
}
.heigth-empty-col
{
    height: 25px;
    min-height: 25px;
    max-height: 25px;

}
.dataandhour{
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-right: 25px;
}

#title-modal{
    font-size: 20px;
    font-weight: bold;
    color: white;
    font-family:'Segoe UI';
    margin: 0;
 }

 #closed-modal{
    height: 40px;
    width: 40px;
    font-weight: bold;
    font-size: 18px;
    display: flex;
    cursor: pointer;
    align-items: center;
 }

/* Customize the appearance of the custom checkbox */

@media  (max-width: 1280px) {
.painel-detalhes-main{
    height: 88vh;
    overflow: auto;
    font-family: 'Segoe UI';
}
.painel-detalhes-main::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 15px;
}
.painel-detalhes-main::-webkit-scrollbar {
    width: 10px;
    height: 10px;
     border-radius: 9px;
    background: #F4F4F4;
}
.painel-detalhes-main::-webkit-scrollbar-thumb {
    background: rgb(192, 193, 192);
    border-radius: 9px;
}

}
@media (min-width: 1281px ) and (max-width: 1400px) {
    .painel-detalhes-main{
        height: 70vh;
        overflow: auto;
        font-family: 'Segoe UI';
    }
}
    </style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/InfoSorting/infoSorting.vue